import { sanitizeAssistantText } from '../../../utils/sanitizeAssistantText';

// Conversation bubble (TASK-499, ports SixEase widgets/ChatMessage). A chat turn is
// just a widget spec pushed into the canvas sink; the Canvas renders it full-width via
// its BARE set, so dialogue and summoned widgets share one scroll surface.
interface ChatMessageProps {
  role?: 'user' | 'assistant';
  text?: string;
}

// TASK-709: the `pending` three-dot branch was dead — no spec producer ever set it;
// the in-flight affordance is canvasStore.pendingStatus → WidgetSkeleton (TASK-601).
export function ChatMessage({ role = 'assistant', text = '' }: ChatMessageProps) {
  if (role === 'user') {
    return (
      <div className="flex justify-end">
        <div className="max-w-[80%] rounded-2xl rounded-br-sm bg-primary/10 px-3.5 py-2 text-[13.5px] leading-relaxed text-foreground">
          {text}
        </div>
      </div>
    );
  }

  const safeText = sanitizeAssistantText(text);

  return (
    <div className="flex items-start gap-2.5">
      <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border border-border bg-accent text-[13px] text-primary">
        ◆
      </div>
      <div className="max-w-[80%] rounded-2xl rounded-tl-sm bg-muted px-3.5 py-2 text-[13.5px] leading-relaxed text-foreground">
        <span className="whitespace-pre-wrap">{safeText}</span>
      </div>
    </div>
  );
}
